import React from "react";
import { SRLWrapper } from "simple-react-lightbox"; // Import SRLWrapper

import kuruyemisT from "../../assets/img/gallery/thumbnail/kuruyemisborsasi-web.jpg"
import kuruyemis from "../../assets/img/gallery/kuruyemisborsasi-web.jpg"
import livaT from "../../assets/img/gallery/thumbnail/liva-web.jpg"
import liva from "../../assets/img/gallery/liva-web.jpg"
import lodaT from "../../assets/img/gallery/thumbnail/loda-web.jpg"
import loda from "../../assets/img/gallery/loda-web.jpg"
import arcadiumT from "../../assets/img/gallery/thumbnail/arcadium-web.jpg"
import arcadium from "../../assets/img/gallery/arcadium-web.jpg"
import cetmenT from "../../assets/img/gallery/thumbnail/cetmen-web.jpg"
import cetmen from "../../assets/img/gallery/cetmen-web.jpg"
import ergulT from "../../assets/img/gallery/thumbnail/ergul-web.jpg"
import ergul from "../../assets/img/gallery/ergul-web.jpg"
import hacibabaT from "../../assets/img/gallery/thumbnail/hacibaba-web.jpg"
import hacibaba from "../../assets/img/gallery/hacibaba-web.jpg"
import konforT from "../../assets/img/gallery/thumbnail/konfor-web.jpg"
import konfor from "../../assets/img/gallery/konfor-web.jpg"
import pakmaya from "../../assets/img/gallery/pakmaya-web.jpg"
import pakmayaPpd from "../../assets/img/gallery/pakmaya-ppd-web.jpg"
import pakmayaMy from "../../assets/img/gallery/pakmaya-my-web.jpg"
import oracle from "../../assets/img/gallery/oracle-web.jpg"
import mehmetcik from "../../assets/img/gallery/mehmetcik-web.jpg"
import matbuu from "../../assets/img/gallery/matbuu-web.jpg"
import linkplus from "../../assets/img/gallery/linkplus-web.jpg"
import ideanest from "../../assets/img/gallery/ideanest-web.jpg"
import pakmayaT from "../../assets/img/gallery/thumbnail/pakmaya-web.jpg"
import pakmayaPpdT from "../../assets/img/gallery/thumbnail/pakmaya-ppd-web.jpg"
import pakmayaMyT from "../../assets/img/gallery/thumbnail/pakmaya-my-web.jpg"
import oracleT from "../../assets/img/gallery/thumbnail/oracle-web.jpg"
import mehmetcikT from "../../assets/img/gallery/thumbnail/mehmetcik-web.jpg"
import matbuuT from "../../assets/img/gallery/thumbnail/matbuu-web.jpg"
import linkplusT from "../../assets/img/gallery/thumbnail/linkplus-web.jpg"
import ideanestT from "../../assets/img/gallery/thumbnail/ideanest-web.jpg"
const List = () => {
  const imgs = [
    {
      thumb: kuruyemisT,
      img: kuruyemis,
      head: 'Kuruyemiş Borsası',
      alt: 'Kuruyemiş Borsası Search Engine Optimization',
    },
    {
      thumb: livaT,
      img: liva,
      head: 'Liva Pastacılık',
      alt: 'Liva Pastacılık Search Engine Optimization',
    },
    {
      thumb: lodaT,
      img: loda,
      head: 'Loda',
      alt: 'Loda Search Engine Optimization',
    },
    {
      thumb: arcadiumT,
      img: arcadium,
      head: 'Arcadium AVM',
      alt: 'Arcadium AVM Search Engine Optimization',
    },
    {
      thumb: cetmenT,
      img: cetmen,
      head: 'Çetmen',
      alt: 'Çetmen Search Engine Optimization',
    },
    {
      thumb: ergulT,
      img: ergul,
      head: 'Ergül Keskin',
      alt: 'Ergül Keskin Search Engine Optimization',
    },
    {
      thumb: hacibabaT,
      img: hacibaba,
      head: 'Kahveci Hacıbaba',
      alt: 'Kahveci Hacıbaba Search Engine Optimization',
    },
    {
      thumb: konforT,
      img: konfor,
      head: 'Konfor',
      alt: 'Konfor Search Engine Optimization',
    },
    {
      thumb: pakmayaT,
      img: pakmaya,
      head: 'Pakmaya',
      alt: 'Pakmaya Websitesi Geliştirme',
    },
    {
      thumb: pakmayaPpdT,
      img: pakmayaPpd,
      head: 'Pakmaya Profesyoneller Dünyası',
      alt: 'Pakmaya Profesyoneller Dünyası Websitesi Geliştirme',
    },
    {
      thumb: pakmayaMyT,
      img: pakmayaMy,
      head: 'Pakmaya Mutfağın Yıldızı',
      alt: 'Pakmaya Mutfağın Yıldızı Websitesi Geliştirme',
    },
    {
      thumb: oracleT,
      img: oracle,
      head: 'Oracle',
      alt: 'Oracle Websitesi Geliştirme',
    },
    {
      thumb: mehmetcikT,
      img: mehmetcik,
      head: 'Mehmetçik Vakfı',
      alt: 'Mehmetçik Vakfı Websitesi Geliştirme',
    },
    {
      thumb: matbuuT,
      img: matbuu,
      head: 'Matbuu',
      alt: 'Matbuu Websitesi Geliştirme',
    },
    {
      thumb: linkplusT,
      img: linkplus,
      head: 'Linkplus',
      alt: 'Linkplus Websitesi Geliştirme',
    },
    {
      thumb: ideanestT,
      img: ideanest,
      head: 'Ideanest',
      alt: 'Ideanest Websitesi Geliştirme',
    }
  ]

  return (
    imgs.map((item, i) => {
      return (
        <div key={i} className="image">
          <div className="hover">
            <a href={item.img} className="thumb" data-attribute="SRL">
              <img alt={item.alt} src={item.thumb} />
            </a>
          </div>
          <p className="img-head">{item.head}</p>
          <p>{item.alt}</p>
        </div>
      )
    })
  );
}


function SeoGallery() {
  return (
    <SRLWrapper>
      <div className="gallery container">
        <List />
      </div>
    </SRLWrapper>
  );
}

export default SeoGallery;